// src/modules/clientes/view/client-gallery/gallery.utils.ts
import { MediaType } from './gallery.types';

export const MAX_MB = 50;

export function makeId() {
    // @ts-ignore
    return crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function detectType(file: File): MediaType {
    return file.type.startsWith('video/') ? 'video' : 'image';
}

export function isBlobUrl(url: string) {
    return typeof url === 'string' && url.startsWith('blob:');
}

export function validateMaxSize(file: File, maxMb = MAX_MB) {
    const maxBytes = maxMb * 1024 * 1024;
    return file.size <= maxBytes;
}

export function bytesToKb(size: number) {
    return Math.round(size / 1024);
}
